export const getContinentFromTimezone = (timezone: string): string => {
  return timezone.split("/")[0];
};
